/**
 * @description Base controller for two separate portal controllers
 * @example
 * // Inside child controller
 * var baseCtrl = $controller('BaseVulnDiscussionCtrl', {$scope: $scope});
 */
;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .controller('BaseVulnDiscussionCtrl', BaseVulnDiscussionCtrl)

  function BaseVulnDiscussionCtrl(
    $scope,
    $routeParams,
    $interval,
    traceCommonRenderService,
    REFRESH_DELAY,
    VULN_DISCUSSION_EVENTS
  ) {
    'ngInject'

    var _traceUuid, _refreshTask, _deregisterTracesOverviewLoadListener

    this.$onInit = function () {
      angular.extend($scope, {
        getTraceUuid: getTraceUuid,
        startRefreshTask: startRefreshTask,
        destroyRefreshTask: destroyRefreshTask,
        emitTraceDiscussionDeleteEvent: emitTraceDiscussionDeleteEvent,
        emitTraceDiscussionAddEvent: emitTraceDiscussionAddEvent,
        changeToEditable: changeToEditable,
        compareDates: compareDates,
        onTracesOverviewLoad: onTracesOverviewLoad,
        getProperty: getProperty,
        isValidProperty: isValidProperty,
        getPropertyItem: getPropertyItem
      })

      init()
    }

    function init() {
      _traceUuid = $routeParams.uuid
      $scope.$on('$destroy', _destroy)
    }

    function _destroy() {
      destroyRefreshTask()
      _deregisterTracesOverviewLoadListener()
    }

    function getTraceUuid() {
      return _traceUuid
    }

    function startRefreshTask(cb) {
      _refreshTask = $interval(cb, REFRESH_DELAY.longDelay, 1)
    }

    function destroyRefreshTask() {
      $interval.cancel(_refreshTask)
    }

    function emitTraceDiscussionDeleteEvent() {
      $scope.$emit(VULN_DISCUSSION_EVENTS.DELETE)
    }

    function emitTraceDiscussionAddEvent() {
      $scope.$emit(VULN_DISCUSSION_EVENTS.ADD)
    }

    function changeToEditable() {
      $scope.destroyRefreshTask()
    }

    function compareDates(note) {
      return traceCommonRenderService.compareDates(note)
    }

    function onTracesOverviewLoad(cb) {
      _deregisterTracesOverviewLoadListener = $scope.$on(
        'traces:overview:load',
        cb
      )
    }

    function getProperty(name) {
      return function (prop) {
        return prop.name === name
      }
    }

    function isValidProperty(properties, name) {
      var property = _.find(properties, { name: name })
      return property && property.value !== null && property.value !== ''
    }

    function getPropertyItem(properties, name) {
      return _.find(properties, { name: name })
    }
  }
})()
